import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { ICommand } from "../../modules/records/commands/i-command";
import { IApiService } from "../../modules/records/models/api/i-api-service";
import { IActionComponent } from "../table-col-configs/action-col";
import { InterviewsService } from "../../services/interviews.service";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { FieldworkReportService } from "../../services/fieldwork-report.service";

import { MyUtils } from "src/app/services/my-utils.service";
import { InterviewsV2Service } from "src/app/services/interviews-v2.service";

@Component({
    selector: "app-table-actions",
    templateUrl: "./table-actions.component.html",
    styleUrls: ["./table-actions.component.scss"],
})
export class TableActionsComponent<T extends object> implements OnInit, IActionComponent<T> {
    @Input() set actions(a: ICommand<T, IApiService<T>>[] | undefined) {
        if (a) {
            this._actions = a;
        }
    }

    _actions: ICommand<T, IApiService<T>>[] = [];

    data: any;
    asyncSliderText = 'Async enabled';
    isInterviewExport = false;

    isFieldworkExport = false;

    get commands() {
        return this._actions;
    }

    constructor(
        private interviewService: InterviewsService,
        private interviewsV2Service: InterviewsV2Service,
        private fieldworkReportService: FieldworkReportService,

        cdr: ChangeDetectorRef,
        public utils: MyUtils
    ) {
    }

    ngOnInit(): void {
    }

    setComponentData() {
    }

    onClick(i: number) {
        this.commands[i].execute();
    }

    isLoading(i: number) {
        return this.commands[i].isLoading || false;
    }

    isDisabled(i: number) {
        let isDisabled = this.commands[i].isDisabled();
        return isDisabled;
    }

    isAsyncEnabled(action: any) {
        this.isInterviewExport = false;
       
        this.isFieldworkExport = false;

        if (action.service.interviewSummaryPath) {
            this.isInterviewExport = true;
        } else if (action.service.fieldowrkReportPath) {
            this.isFieldworkExport = true;
        } 
        return !!(action.service.interviewSummaryPath || action.service.fieldowrkReportPath || action.service.appealDetailsPath);

    }

    sliderAction(e: MatSlideToggleChange) {
        this.asyncSliderText = e.checked ? 'Async enabled' : 'Sync enabled';

    
        if (this.isFieldworkExport) {
            this.fieldworkReportService.isFieldworkReportAsync = e.checked;
        }
        if (this.isInterviewExport) {
            this.interviewService.isInterviewSync = e.checked;
            this.interviewsV2Service.isInterviewSync = e.checked;
        }

    }
}
